import { LoadingStatus } from './app.state';

export const switchToFailure = <T extends { status: LoadingStatus }, R>(state: T, props: R): T => ({ ...state, status: 'failure' });
